var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "negate-parent-padding" },
    [
      !_vm.isNeutral
        ? _c(
            "b-table-simple",
            [
              _c(
                "b-tr",
                [
                  _vm.showInsuranceFigureLabel
                    ? _c("b-td", [
                        _vm._v("\n                netto\n            "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-td", { class: _vm.netWrapperClasses }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formatCurrencyCents(_vm.amountNet)) +
                        "\n            "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.costUnit.amountCopayment
                ? _c(
                    "b-tr",
                    [
                      _vm.showInsuranceFigureLabel
                        ? _c("b-td", [
                            _vm._v("\n                SB\n            "),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-td", { staticClass: "text-right" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.formatCurrencyCents(_vm.amountCopayment)
                            ) +
                            "\n            "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-tr",
                [
                  _vm.showInsuranceFigureLabel
                    ? _c("b-td", [
                        _vm._v("\n                Ust.\n            "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-td", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formatCurrencyCents(_vm.amountVat)) +
                        "\n            "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "tr",
                [
                  _vm.showInsuranceFigureLabel
                    ? _c("b-td", [
                        _c("span", { staticClass: "font-weight-bold" }, [
                          _vm._v("Summe"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-td", { class: _vm.grossWrapperClasses }, [
                    _c(
                      "div",
                      { staticClass: "font-weight-bold text-nowrap" },
                      [
                        _vm._t("amountPrefix"),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formatCurrencyCents(_vm.amount)) +
                            "\n                "
                        ),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isNeutral
        ? _c(
            "b-table-simple",
            { attrs: { borderless: "" } },
            [
              _vm.showInsuranceFigureLabel
                ? _c("b-td", [_vm._v("\n            Steuerneutral\n        ")])
                : _vm._e(),
              _vm._v(" "),
              _c("b-td", { class: _vm.neutralWrapperClasses }, [
                _c(
                  "div",
                  { staticClass: "font-weight-bold text-nowrap" },
                  [
                    _vm._t("amountPrefix"),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formatCurrencyCents(_vm.amount)) +
                        "\n            "
                    ),
                  ],
                  2
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }